const LOAD_DETAIL_EMPLOYERS_INQUIRIES           = 'LOAD_DETAIL_EMPLOYERS_INQUIRIES'
const LOAD_DETAIL_EMPLOYERS_INQUIRIES_SUCCESS   = 'LOAD_DETAIL_EMPLOYERS_INQUIRIES_SUCCESS'
const LOAD_DETAIL_EMPLOYERS_INQUIRIES_FAILED    = 'LOAD_DETAIL_EMPLOYERS_INQUIRIES_FAILED'
const UNMOUNT_DETAIL_EMPLOYERS_INQUIRIES        = 'UNMOUNT_DETAIL_EMPLOYERS_INQUIRIES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const employersDetailInquiriesReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_EMPLOYERS_INQUIRIES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_EMPLOYERS_INQUIRIES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_EMPLOYERS_INQUIRIES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_EMPLOYERS_INQUIRIES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default employersDetailInquiriesReducer;